const podcastContentType = {
    default: 1,
    torahAnytime: 2,
    torahAnytimePlaylist: 3,
};

export default podcastContentType;
